export default __webpack_public_path__ + "static/media/logouticonactive.d3c30405.svg";